(function($) {

	$.fn.multiButton = function(options) {
		// build main options before element iteration
		var opts = $.extend( {}, $.fn.multiButton.defaults, options);

		return this.each(function() {
			var $this = $(this);
			// build element specific options
            var eOpts = $.metadata ? $.extend(true, {}, opts, $this.metadata()) : opts;
            eOpts = $.fn.dataset ? $.extend(true, eOpts, $this.dataset()) : eOpts;

            $this
                .find('button, a.button')
                    .msxibutton(eOpts)
                    .removeAttr('title')
                    .click(function() {
                        var menu = $( this ).parent().find('ul').show().position({
                            my: "right top",
                            at: "right bottom",
                            of: this
                        });
                        $(document).one( "click", function() {
                            menu.hide();
                        });
                        return false;
                    })
                .parent().find('ul')
                    .hide()
                    .menu()
                // Menu item focus only works if the <a> is a child of <li>, otherwise do it manually
                .find('li > * a').addClass('ui-corner-all').hover(function(){
                    $(this).addClass('ui-state-focus');
                }, function(){
                    $(this).removeClass('ui-state-focus');
                });
        });
	};
	//
	// plugin defaults
	//
	$.fn.multiButton.defaults = {
	};

})(jQuery);